import { render, staticRenderFns } from "./ReceiveFTM.vue?vue&type=template&id=2584966f&"
import script from "./ReceiveFTM.vue?vue&type=script&lang=js&"
export * from "./ReceiveFTM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports